export const EXTENDED_FIELDS = "ExtendedFields";
export const CREATE_ADDON_GIFT = "CreateAddOnGift";
export const CTA_EDITOR = "CtaEditor";
export const ALERT_EDITOR = "AlertEditor";
export const STAX_KYC = "StaxKYC";
export const STAX_STATUS = "StaxStatus";
export const GIFT_REFUND = "GiftRefund";
export const FNC_UPGRADE = "FNCUpgrade";
export const SACRAMENT_HISTORY = "SacramentHistory";
export const EMERGENCY_CONTACT_HISTORY = "EmergencyContactHistory";
export const MEDICAL_ALLERGY_HISTORY = "MedicalAllergyHistory";
export const SACRAMENT_TRACKING = "SacramentTracking";
export const TWO_FA_ENROLLMENT = "twofaEnrollment";
export const TWO_FA_DISENROLLMENT = "twofaDisenrollment";
export const MANAGE_PROXY_CONTACTS = "manageProxyContacts";
export const FAMILY_RELATIONSHIP_PICKER = "familyRelationshipPicker";
export const EXTENDED_FIELD_HISTORY = "extendedFieldHistory";
export const EVERYONE_REMOVE_MEMBER_CONFIRMATION =
  "everyoneRemoveMemberConfirmation";
export const PARENT_GROUP_PERMISSION_CONFLICT = "parentGroupPermissionConflict";
export const ASK_THE_MEMBER = "askTheMember";
export const CONTACT_HISTORY = "contactHistory";
export const DONOR_SUMMARY_REPORTS = "donorSummaryReports";
export const CREATE_GROUP = "CreateGroup";
export const FNC_SMART_GROUP_PROMO = "FncSmartGroupPromo";
export const FAMILY_REGISTRATION_SPLASH = "FamilyRegistrationSplash";
export const GIVING_SPLASH = "GivingSplash";
export const CAMPAIGNS_SPLASH = "CampaignsSplash";
export const NEW_CAMPAIGN = "NewCampaign";
export const MANAGE_MY_GIVING_SPLASH = "ManageMyGivingSplash";
export const FNC_SMART_GROUP_UPGRADE_GROUP_LIMIT =
  "SmartGroupUpgradeGroupLimit";
export const PREPARING_EXPORT = "PreparingExport";

export const LEGAL_ENTITY_INFO = "LegalEntityInfo";
export const CREATE_PRAYER_REQUEST = "CreatePrayerRequest";
export const SMALL_CHURCH_ATTESTATION = "SmallChurchAttestation";
export const TTJ_ACTION_FLOW = "TTJActionFlow";
export const IMPORTING = "Importing";
export const TRANSFER_PARTIAL_CONTACT_VIEW_IN_SHEET =
  "partialConflictViewInSheet";
export const CREATE_GIVING_HOUSEHOLD = "CreateGivingHousehold";
export const CAMPAIGN_WIZARD = "CampaignWizard";
export const CREATE_PLEDGE = "CreatePledge";
export const CREATE_PLEDGE_OVERLAY = "CreatePledgeOverlay";
export const CREATE_FUND = "CreateFund";
export const PLEDGE_DETAIL = "PledgeDetail";
export const ARCHIVE_USER = "ArchiveUser";
export const MAKE_SUBGROUP = "MakeSubgroup";
export const REMOVE_SUB_FUND = "RemoveSubFund";
export const RE_SETUP_WIZARD = "RESetupWizard";
export const DISCOUNT_DETAIL_MODAL = "DiscountDetailModal";
export const ADD_BATCH_GIFT = "AddBatchGift";
export const ADD_TO_PARISH = "AddToParish";
export const BILLING_LOCKOUT = "BillingLockout";
export const CANCEL_FLOCKNOTE_COMPLETE = "CancelFlocknoteComplete";
export const EDIT_PLEDGE = "EditPledge";
export const PLEDGE_HISTORY = "PledgeHistory";
export const PAYMENT_DATES = "PaymentDates";
export const ADD_PAYMENT_METHOD = "AddPaymentMethod";
export const ARCHIVE_FUND = "ArchiveFund";
